import { render, staticRenderFns } from "./ParkingSpots.vue?vue&type=template&id=5a7a2f72&scoped=true"
import script from "./ParkingSpots.vue?vue&type=script&lang=js"
export * from "./ParkingSpots.vue?vue&type=script&lang=js"
import style0 from "./ParkingSpots.vue?vue&type=style&index=0&id=5a7a2f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7a2f72",
  null
  
)

export default component.exports